import { render, staticRenderFns } from "./LocationsTab.vue?vue&type=template&id=7fc68456"
import script from "./LocationsTab.vue?vue&type=script&lang=js"
export * from "./LocationsTab.vue?vue&type=script&lang=js"
import style0 from "./LocationsTab.vue?vue&type=style&index=0&id=7fc68456&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc68456')) {
      api.createRecord('7fc68456', component.options)
    } else {
      api.reload('7fc68456', component.options)
    }
    module.hot.accept("./LocationsTab.vue?vue&type=template&id=7fc68456", function () {
      api.rerender('7fc68456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Settings/LocationsTab.vue"
export default component.exports